import React from "react"

import Result from "./Result"

import * as style from "./Search.module.scss"

const Results = ({ engine, microcopy, focused }) => (
  <>
    {engine.state.results && engine.state.results[0] ? (
      <div className={style.wrapper}>
        <ul className={style.results}>
          {engine.state.results.map((result, index) => (
            <Result
              key={index}
              result={result}
              index={index}
              engine={engine}
              microcopy={microcopy}
              focused={focused}
            />
          ))}
        </ul>
      </div>
    ) : (
      <div className={style.wrapper}>
        <ul className={style.results} />
      </div>
    )}
  </>
)

export default Results
